/*
 * OfferChilds Constants
 */

export const SET_OFFER_MONTHLY_RATE =
  'ideal/OfferChilds/SET_OFFER_MONTHLY_RATE';
export const SET_CHILDS_DEPOSIT = 'ideal/OfferChilds/SET_OFFER_DEPOSIT';
export const SET_CHILDS_DURATION = 'ideal/OfferChilds/SET_OFFER_DURATION';
export const SET_CHILDS_MONTHLY_RATE =
  'ideal/OfferChilds/SET_CHILDS_MONTHLY_RATE';
export const SET_CHILDS_DISTANCE =
  'ideal/OfferChilds/SET_CHILDS_DISTANCE';
export const SET_CHILDS_SECOND_DISTANCE =
  'ideal/OfferChilds/SET_CHILDS_SECOND_DISTANCE';
export const SET_CHILDS_THIRD_DISTANCE =
  'ideal/OfferChilds/SET_CHILDS_THIRD_DISTANCE';

export const SET_LOADING = 'ideal/OfferChilds/SET_LOADING';
export const STORE_CHILD_OFFER = 'ideal/OfferChilds/STORE_CHILD_OFFER';
export const UPDATE_CHILD_OFFER = 'ideal/OfferChilds/UPDATE_CHILD_OFFER';
export const EDIT_CHILD_OFFER = 'ideal/OfferChilds/EDIT_CHILD_OFFER';
export const EDIT_CHILD_OFFER_END = 'ideal/OfferChilds/EDIT_CHILD_OFFER_END';
export const ADD_CHILD_OFFER = 'ideal/OfferChilds/ADD_CHILD_OFFER';
export const REPLACE_CHILD_OFFER = 'ideal/OfferChilds/REPLACE_CHILD_OFFER';

export const DELETE_CHILD_OFFER = 'ideal/OfferChilds/DELETE_CHILD_OFFER';
export const REMOVE_CHILD_OFFER = 'ideal/OfferChilds/REMOVE_CHILD_OFFER';

export const SET_CHILD_OFFERS = 'ideal/OfferChilds/SET_CHILD_OFFERS';

export const VALIDATE_USER_INPUT = 'ideal/OfferChilds/VALIDATE_USER_INPUT';
export const SET_ERROR_MESSAGE = 'ideal/OfferChilds/SET_ERROR_MESSAGE';

export const RESET = 'ideal/OfferChilds/RESET';
export const RESET_ERRORS = 'ideal/OfferChilds/RESET_ERRORS';
